var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { commonCssStyles } from "../../global-styles.js";
let LanguageSelectorMenu = class LanguageSelectorMenu extends LitElement {
    render() {
        return html ` <ul class="container drop-shadow-10" role="presentation">
      <slot></slot>
    </ul>`;
    }
};
LanguageSelectorMenu.styles = [
    commonCssStyles,
    css `
      .container {
        background-color: var(--Neutral-Dark-Helix-0);
        display: flex;
        min-width: 150px;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 8px;
        background: var(--Neutral-Dark-Helix-0);
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        overflow: hidden;
      }
    `,
];
LanguageSelectorMenu = __decorate([
    customElement("language-selector-menu")
], LanguageSelectorMenu);
export { LanguageSelectorMenu };
